// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReviewSearchResponse

import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';

export type ReviewSearchApiResponse = {
	items: BookingApiResponse[];
};

export type ReviewSearch = {
	items: Booking[];
};

export function hydrateReviewSearch(data: ReviewSearchApiResponse): ReviewSearch {
	return {
		...data,
		items: data.items.map(hydrateBooking),
	};
}